import { apiRequest } from '../../../api/client';
import { ACTIVITY_BATCH_SIZE } from '../../../components/ui/list-batch-sizes';
import type { ActivityCategory, MachineActivityResponseDto } from '../types/activity';

export function getMachineActivity(machineId: string, category: ActivityCategory = 'ALL', cursor?: string | null, limit = ACTIVITY_BATCH_SIZE) {
  const params = new URLSearchParams({ category, limit: String(limit) });
  if (cursor) params.set('cursor', cursor);
  return apiRequest<MachineActivityResponseDto>(
    `/v1/machines/${encodeURIComponent(machineId)}/activity?${params.toString()}`,
  );
}
